import PortalLayout from "@/components/PortalLayout";
import CommercialValueCenterBody from "@/pages/shared/CommercialValueCenterBody";

const CommercialValueCenter = () => (
  <PortalLayout>
    <CommercialValueCenterBody editable={false} />
  </PortalLayout>
);

export default CommercialValueCenter;
